import styled from 'styled-components';
import { StyledProductBadgeProps } from './ProductBadge.types';

export const StyledProductBadge = styled.div<StyledProductBadgeProps>`
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  left: ${(props) => (props.text ? 'auto' : 0)};
  bottom: ${(props) => (props.text ? 'auto' : 0)};
  transform-origin: top right;
  background-image: ${(props) =>
    props.text && props.text.length
      ? 'url(https://assets.playosmo.com/static/ui-library/badge-blank-cropped.png)'
      : props.url
      ? `url(${props.url})`
      : 'none'};
  background-repeat: no-repeat;
  background-size: contain;

  width: ${(props) => {
    return props.width ? props.width : props.text ? '32%' : 'auto';
  }};
  min-width: ${(props) => {
    return props.width ? props.width : props.text ? '80px' : 'auto';
  }};

  &:after {
    content: '';
    display: ${(props) => (props.text ? 'block' : 'none')};
    padding-bottom: 100%;
  }

  .product-badge__svg {
    transform: rotate(349deg);
    fill: white;
    line-height: 14px;
    font-size: 1.15em;
    font-weight: 700;
  }

  .product-badge__svg-text--off {
    font-size: 0.61em;
  }

  .product-badge__text-wrapper {
    position: absolute;
    right: 14%;
    top: 0;
    left: 14%;
    bottom: 0;
  }

  .product-badge__text {
    line-height: 14px;
    position: absolute;
    color: #fff;
    font-weight: 700;
    text-align: center;
    top: 50%;
    left: 52%;
    max-width: 100%;
    transform: translate(-50%, -50%) rotate(-9deg);
  }

  ${(props) => props.customStyle}
`;
